<template>

  <div class="event-details-box">
    <div class="event-registration-box">
      <payment-summary :formTitle="eventConfig['names-label-your-total']" priceTitle="" :products="products" :donationPrice="0"/>
    </div>
    <div class="event-form-wrap event-box-shadow">
    <div class="event-rg-form">
      <h6 class="mb-3">{{ eventConfig['payment-label-details'] }}</h6>
      <div class="form-payment">
        <div>
          <div class="event-rg-form event-form-step1">
            <div v-loading="processing" element-loading-text="Processing...">
              <el-alert v-if="errors" type="error" show-icon ref="alert-item">
                <p v-html="errors" />
              </el-alert>
              <h5 class="text-center mt-5 mb-5">Payment is not required</h5>
              <p class="text-center">Please ensure that you click ‘Submit’ below to register.</p>
            </div>
          </div>
          <hr />
          <div class="event-btn d-flex flex-wrap event-rg-form">
            <button @click="onBackClick" class="btn btn-secondary" :disabled="processing">Back</button>
            <button @click="onNextClick" class="btn btn-primary" :disabled="processing">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div><!-- /.event-else-wrapper -->


</template>

<script>
import { mapActions } from "vuex";
import PaymentSummary from '../../_FormElements/PaymentSummary.vue';
export default {
  components: {
    PaymentSummary
  },
  props: {
    tickets: { type: Array, required: true },
    eventConfig: { type: Object, required: true },
    userRoles: { type: [String, Object, Array] },
    participants: { type: [Object, Array], required: true }
  },
  data: function () {
    return {
      processing: false,
      errors: null,
    };
  },
  
  computed: {
    products: function () {
      const items = this.tickets.map(ticket => ({
        'product-code': ticket.code,
        'product-description': ticket.name,
        'total-price': ticket.total
      }));

      return items;
    },
  },
  methods: {
    ...mapActions('eventRegistration', ['sendPayment']),
    onBackClick: function (payload = 3) {
      this.$emit('next-step', { step: payload });
    },
     onNextClick: async function () {
      this.processing = true;
      this.errorTx = false;
      this.errors = null;

     const payload = {
        PaymentType: 'complimentary',
        PayorType: 'Individual'
      }

      const receipt = await this.sendPayment(payload);

      if (receipt.ResponseStatus === 'success') {
        this.$emit('next-step', {step: 5, receiptInfo: receipt});
      } else {
        this.errorTx = true;
        this.errors = receipt.Errors[0];
      }
      
      this.processing = false;
    }
  }
}
</script>


